import {Component, OnInit} from "@angular/core";
import {ActivatedRoute} from "@angular/router";
import {ObjectBaseModeComponent} from "../../../../../../core/shared/object/mvs-object-base/object-base-mode.component";
import {WidgetData} from "../../../../../../core/shared/widget/widget-data";
import {WidgetFactory} from "../../../../../../core/shared/widget/service/widget.factory";
import {FilterCriteria} from "../../../../../../core/shared/filter/api/filter.criteria";

@Component({
    selector: 'hc-integration-base-component',
    template: '',
    standalone: false
})

export class IntegrationAdapterTypeBaseComponent extends ObjectBaseModeComponent implements OnInit {


    integrationAdapterTypeWidget: WidgetData;
    integrationAdapterTypeVariableWidget: WidgetData;

    constructor(protected route: ActivatedRoute) {
        super(route);

    }

    ngOnInit() {

        this.activeNavigationItem = this.navigationItems.find(item => item.default);
        this.onNavigationItems.emit(this.navigationItems);
        super.ngOnInit();

        this.refreshIntegrationAdapterTypeWidget();
        this.refreshIntegrationAdapterTypeVariableWidget();

    }

    refreshIntegrationAdapterTypeWidget() {
        this.integrationAdapterTypeWidget = WidgetFactory.createWidgetEntityData(
            'hc.integration.adapter.type.data.widget',
            'Adapter Type',
            'hc.IntegrationAdapterType',
            this.objectIdentifier.objectId
        )
    }

    refreshIntegrationAdapterTypeVariableWidget() {

        const filterCriteria = FilterCriteria.create('e.integrationAdapterTypeId', FilterCriteria.cOperatorEqual, this.objectIdentifier.objectId);

        this.integrationAdapterTypeVariableWidget = WidgetFactory.createWidgetTableEntityBasicQl('hc.integration.adapter.type.variable.table.widget', 'Adapter Type Variable', 'hc.IntegrationAdapterTypeVariable', [filterCriteria])
    }

}
